// import styles from "components/RenderArrow/styles.module.scss";

import { SettingsContext } from "context";
import { FC, useContext } from "react";
// const { currentDemo } = useContext(SettingsContext);

export type ArrowConfigArrays = {
  landing_page: ArrowConfig[];
  chat_bot: ArrowConfig[];
  social_media_campaign: ArrowConfig[];
  shopping_copilot_new: ArrowConfig[];
  call_center: ArrowConfig[];
  call_center_before_summary: ArrowConfig[];
  call_center_before_script: ArrowConfig[];
  customer_conversation: ArrowConfig[];
  call_center_after_summary: ArrowConfig[];
  call_center_after_script: ArrowConfig[];
  shopping_copilot: ArrowConfig[];
  world_map: ArrowConfig[];
  ceo_dashboard_before: ArrowConfig[];
  city_view: ArrowConfig[];
  ceo_dashboard_after: ArrowConfig[];
  finale_video: ArrowConfig[];
  org_chart: ArrowConfig[];
  shopping_copilot_cosmos: ArrowConfig[];
  shopping_assistant_cosmos: ArrowConfig[];
  chat_bot_2: ArrowConfig[];
  shopping_copilot_uat: ArrowConfig[];
  shopping_copilot_mtc: ArrowConfig[];
};

interface ToolTip {
  id: number;
  url: keyof ArrowConfigArrays;
  value: string;
}

export const toolTips: ToolTip[] = [
  { id: 0, url: "landing_page", value: "Landing Page" },
  {
    id: 1,
    url: "chat_bot",
    value: "Azure OpenAI Chatbot for Enterprise Data",
  },
  {
    id: 2,
    url: "social_media_campaign",
    value: "Social Media Campaign & Product Recommendation",
  },
  { id: 10, url: "shopping_copilot_new", value: "Shopping Copilot" },
  {
    id: 3,
    url: "call_center_before_summary",
    value: "Call Center Report Before - Summary",
  },
  {
    id: 4,
    url: "call_center_before_script",
    value: "Call Center Report Before - Script",
  },
  {
    id: 5,
    url: "customer_conversation",
    value: "Customer Conversation",
  },
  {
    id: 6,
    url: "call_center",
    value: "Call Center - Generate Summary",
  },
  {
    id: 7,
    url: "call_center_after_script",
    value: "Call Center Report After - Script",
  },
  {
    id: 8,
    url: "call_center_after_summary",
    value: "Call Center Report After - Summary",
  },
  { id: 9, url: "shopping_copilot", value: "Shopping Copilot" },
  { id: 10, url: "world_map", value: "World Map" },
  { id: 11, url: "ceo_dashboard_before", value: "CEO Dashboard - Before" },
  { id: 12, url: "city_view", value: "Beach View" },
  { id: 13, url: "ceo_dashboard_after", value: "CEO Dashboard - After" },
  { id: 14, url: "finale_video", value: "Finale Video" },
  { id: 15, url: "org_chart", value: "ORG Chart" },
  { id: 16, url: "shopping_copilot_cosmos", value: "Shopping Copilot" },
  { id: 17, url: "shopping_assistant_cosmos", value: "Shopping Assistant" },
  {
    id: 18,
    url: "chat_bot_2",
    value: "Azure OpenAI Chatbot for Enterprise Data",
  },
  {
    id: 19,
    url: "shopping_copilot_uat",
    value: "Shopping Copilot",
  },
  {
    id: 20,
    url: "shopping_copilot_mtc",
    value: "Shopping Copilot MTC/EBC Demo",
  },
];

// all route definitions are `snake_case`. The urls are generated by exchanging
// underscores (_) with dashes (-)
// this object determines the order for all routes
// TODO: Type does not work - purely informational
export const mainFlow: Array<keyof ArrowConfigArrays> = [
  "landing_page",
  // "shopping_copilot_new",
  "chat_bot",
  "social_media_campaign",
  "call_center_before_summary",
  "call_center_before_script",
  "customer_conversation",
  "call_center",
  "call_center_after_script",
  "call_center_after_summary",
  // "florence_recommendation",
  // "call_center",
  // "smart_factory",
];

export const routeDefinitions = {
  mainFlow,
};

export type ArrowConfig = {
  c?: string; // classname
  a?: string; // arrowname
  l?: string; // link
  n?: keyof ArrowConfigArrays; // next
  openInNewTab?: boolean;
  t?: "default" | "skip" | "custom";
};

export const arrowConfig: ArrowConfigArrays = {
  // location_analytics: [{ t: "default" }],
  landing_page: [{ t: "default" }],
  shopping_copilot: [{ t: "default" }],
  shopping_copilot_new: [{ t: "default" }],
  chat_bot: [{ t: "default" }],
  chat_bot_2: [{ t: "default" }],
  social_media_campaign: [{ t: "default" }],
  call_center_before_summary: [
    // { t: "default", a: "Arrow-4.png", n: "landing_page" },
  ],
  call_center_before_script: [
    // { t: "default", a: "Arrow-4.png", n: "landing_page" },
  ],
  customer_conversation: [
    // { t: "default", a: "Arrow-4.png", n: "landing_page" },
  ],
  call_center: [
    { t: "default", a: "Arrow-C.png", n: "call_center_after_script" },
  ],
  call_center_after_script: [
    // { t: "default", a: "Arrow-4.png", n: "landing_page" },
  ],
  call_center_after_summary: [
    // { t: "default", a: "Arrow-4.png", n: "landing_page" },
  ],
  world_map: [{ t: "default" }],
  org_chart: [{ t: "default" }],
  ceo_dashboard_after: [{ t: "default", a: "Arrow-10.png" }],
  ceo_dashboard_before: [{ t: "default" }],
  finale_video: [{ t: "default", n: "landing_page", a: "Arrow-11.png" }],
  city_view: [{ t: "default" }],
  shopping_copilot_cosmos: [{ t: "default" }],
  shopping_assistant_cosmos: [{ t: "default" }],
  shopping_copilot_uat: [{ t: "default" }],
  shopping_copilot_mtc: [{ t: "default" }],
};
